import i18n from 'i18next';
import { reactI18nextModule } from 'react-i18next';
import LocizeBackend from 'i18next-locize-backend';

i18n
  .use(reactI18nextModule)
  .use(LocizeBackend)
  .init({
    fallbackLng: 'en',
    appendNamespaceToCIMode: true,
    saveMissing: false,
    // have a common namespace used around the full app
    ns: ['translations'],
    defaultNS: 'translations',
    keySeparator: '::',
    debug: false,

    backend: {
      projectId: 'ec9433b4-a6b8-4dc2-bd14-2c3d808fbf51',
      referenceLng: 'en',
      version: 'latest'
    },

    interpolation: {
      escapeValue: false, // not needed for react!!
    },

    react: {
      wait: true,
      defaultTransParent: 'p'
    }
  });

export default i18n;



// WEBPACK FOOTER //
// ./src/i18n/prod.js